import {
  notificationsSettings,
  UserProfileResponce,
  UserProfileSocket,
} from ".";
import { authNoTokenDTO } from "../auth";
import { RoleType } from "../users";
export const USER_PROFILE = {
  REQUEST: "USER_PROFILE.USER_PROFILE_REQUEST",
  SUCCESS: "USER_PROFILE.USER_PROFILE_SUCCESS",
  FAILURE: "USER_PROFILE.USER_PROFILE_FAILURE",

  REQUEST_FOR_CHECK_TOKEN: "REQUEST_FOR_CHECK_TOKEN.USER_PROFILE_REQUEST",
  SUCCESS_FOR_CHECK_TOKEN: "SUCCESS_FOR_CHECK_TOKEN.USER_PROFILE_SUCCESS",
  FAILURE_FOR_CHECK_TOKEN: "FAILURE_FOR_CHECK_TOKEN.USER_PROFILE_FAILURE",

  EDIT_AVATAR_REQUEST: "USER_PROFILE.EDIT_USER_AVATAR_REQUEST",
  EDIT_AVATAR_SUSSESS: "USER_PROFILE.EDIT_USER_AVATAR_SUSSESS",
  EDIT_AVATAR_FAILURE: "USER_PROFILE.EDIT_USER_AVATAR_FAILURE",

  CHANGE_SELECTED_NODE_ID: "USER_PROFILE.CHANGE_SELECTED_NODE_ID",
  CHANGE_SELECTED_END_NODE_ID: "USER_PROFILE.CHANGE_SELECTED_END_NODE_ID",
  CHANGE_MONITOR_NODE_ID: "USER_PROFILE.CHANGE_MONITOR_NODE_ID",
  GET_PROFILE_BY_SOCKET: "USER_PROFILE.GET_PROFILE_BY_SOCKET",

  EDIT_PROFILE_REQUEST: "USER_PROFILE.EDIT_PROFILE_REQUEST",
  EDIT_PROFILE_SUSSESS: "USER_PROFILE.EDIT_PROFILE_SUSSESS",
  EDIT_PROFILE_FAILURE: "USER_PROFILE.EDIT_PROFILE_FAILURE",

  DELETE_USER_AVATAR: "USER_PROFILE.DELETE_USER_AVATAR",
  DELETE_USER_AVATAR_SUSSESS: "USER_PROFILE.DELETE_USER_AVATAR_SUSSESS",
  DELETE_USER_AVATAR_FAILURE: "USER_PROFILE.DELETE_USER_AVATAR_FAILURE",

  CHANGE_LANGUAGE: "USER_PROFILE.CHANGE_LANGUAGE",
  CHANGE_LANGUAGE_SUSSESS: "USER_PROFILE.CHANGE_LANGUAGE_SUSSESS",
  CHANGE_LANGUAGE_FAILURE: "USER_PROFILE.CHANGE_LANGUAGE_FAILURE",

  DELETE_NODE_BY_SOCKETS: "USER_PROFILE.DELETE_NODE_BY_SOCKETS",

  CHANGE_NOTIFICATION: "USER_PROFILE.CHANGE_NOTIFICATION",
  CHANGE_NOTIFICATION_SUSSESS: "USER_PROFILE.CHANGE_NOTIFICATION_SUSSESS",
  CHANGE_NOTIFICATION_FAILURE: "USER_PROFILE.CHANGE_NOTIFICATION_FAILURE",
  CHANGE_NOTIFICATION_BY_SOCKETS: "USER_PROFILE.CHANGE_NOTIFICATION_BY_SOCKETS",

  SET_USER_ID: "USER_PROFILE.SET_USER_ID",
  SET_USER_ROLE: "USER_PROFILE.SET_USER_ROLE",
  SET_USER_DATA_FROM_AUTH: "USER_PROFILE.SET_USER_DATA_FROM_AUTH",
};

export interface IGetUserProfileBySocket {
  type: typeof USER_PROFILE.GET_PROFILE_BY_SOCKET;
  payload: UserProfileSocket;
}

export interface IUserProfileRequestAction {
  type: typeof USER_PROFILE.REQUEST;
  payload: { withErrorMessage: boolean };
}

export interface IUserProfileSuccessAction {
  type: typeof USER_PROFILE.SUCCESS;
  payload: UserProfileResponce;
}

export interface IUserProfileFailureAction {
  type: typeof USER_PROFILE.FAILURE;
  payload: any;
}

export interface IUserProfileChangeSelectedNdeAction {
  type: typeof USER_PROFILE.CHANGE_SELECTED_NODE_ID;
  payload: number;
}

export interface IUserProfileChangeSelectedENDNodeAction {
  type: typeof USER_PROFILE.CHANGE_SELECTED_END_NODE_ID;
  payload: number;
}

export interface IUserProfileChangeMonitorNodeAction {
  type: typeof USER_PROFILE.CHANGE_MONITOR_NODE_ID;
  payload: number;
}

export interface IUserProfileDeleteNodeActionBySockets {
  type: typeof USER_PROFILE.DELETE_NODE_BY_SOCKETS;
  payload: number[];
}

export interface IEditUserAvatarRequest {
  type: typeof USER_PROFILE.EDIT_AVATAR_REQUEST;
  payload: File;
}
export interface IEditUserAvatarSuccess {
  type: typeof USER_PROFILE.EDIT_AVATAR_SUSSESS;
  payload: string;
}
export interface IEditUserAvatarFailure {
  type: typeof USER_PROFILE.EDIT_AVATAR_FAILURE;
  payload: any;
}

export interface IEditUserProfileRequest {
  type: typeof USER_PROFILE.EDIT_PROFILE_REQUEST;
  payload: { firstName: string; lastName: string };
}
export interface IEditUserProfileSuccess {
  type: typeof USER_PROFILE.EDIT_PROFILE_SUSSESS;
  payload: string;
}
export interface IEditUserProfileFailure {
  type: typeof USER_PROFILE.EDIT_PROFILE_FAILURE;
  payload: any;
}

export interface IDeleteUserAvatarRequest {
  type: typeof USER_PROFILE.DELETE_USER_AVATAR_SUSSESS;
  payload: any;
}
export interface IDeleteUserAvatarSuccess {
  type: typeof USER_PROFILE.DELETE_USER_AVATAR_SUSSESS;
  payload: any;
}
export interface IDeleteUserAvatarFailure {
  type: typeof USER_PROFILE.DELETE_USER_AVATAR_FAILURE;
  payload: any;
}

export interface IChangeLanguage {
  type: typeof USER_PROFILE.CHANGE_LANGUAGE;
  payload: { language: string; withPreload: boolean };
}

export interface IChangeLanguageSuccess {
  type: typeof USER_PROFILE.CHANGE_LANGUAGE_SUSSESS;
  payload: any;
}

export interface IChangeLanguageFailure {
  type: typeof USER_PROFILE.CHANGE_LANGUAGE_FAILURE;
  payload: any;
}
export interface IChangeNotification {
  type: typeof USER_PROFILE.CHANGE_NOTIFICATION;
  payload: { userId: string; value: notificationsSettings };
}
export interface IChangeNotificationSuccess {
  type: typeof USER_PROFILE.CHANGE_NOTIFICATION_SUSSESS;
  payload: notificationsSettings;
}
export interface IChangeNotificationFailure {
  type: typeof USER_PROFILE.CHANGE_NOTIFICATION_FAILURE;
  payload: any;
}

export interface IChangeNotificationSockets {
  type: typeof USER_PROFILE.CHANGE_NOTIFICATION_BY_SOCKETS;
  payload: { userId: string; value: notificationsSettings };
}

export interface ISetUserProfileIdFromToken {
  type: typeof USER_PROFILE.SET_USER_ID;
  payload: string;
}
export interface ISetUserProfileRoleFromToken {
  type: typeof USER_PROFILE.SET_USER_ROLE;
  payload: RoleType;
}
export interface ISetDataFromAuth {
  type: typeof USER_PROFILE.SET_USER_ROLE;
  payload: authNoTokenDTO;
}
export type UserProfileActionTypes =
  | IUserProfileRequestAction
  | IUserProfileSuccessAction
  | IUserProfileFailureAction
  | IUserProfileChangeSelectedNdeAction
  | IEditUserAvatarRequest
  | IEditUserAvatarSuccess
  | IEditUserAvatarFailure
  | IGetUserProfileBySocket
  | IEditUserProfileRequest
  | IEditUserProfileSuccess
  | IEditUserProfileFailure
  | IDeleteUserAvatarRequest
  | IDeleteUserAvatarSuccess
  | IDeleteUserAvatarFailure
  | IUserProfileDeleteNodeActionBySockets
  | IChangeLanguage
  | IChangeLanguageSuccess
  | IChangeLanguageFailure
  | IUserProfileChangeMonitorNodeAction
  | IChangeNotificationSockets
  | ISetUserProfileIdFromToken
  | ISetUserProfileRoleFromToken
  | ISetDataFromAuth;
